import { render, staticRenderFns } from "./DownloadActions.vue?vue&type=template&id=7fb47c70&scoped=true"
import script from "./DownloadActions.vue?vue&type=script&lang=js"
export * from "./DownloadActions.vue?vue&type=script&lang=js"
import style0 from "./DownloadActions.vue?vue&type=style&index=0&id=7fb47c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb47c70",
  null
  
)

export default component.exports